import React from "react";
import { ThemePaletteState, ThemeShadowSizes, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";

/**
 *
 */
interface Props {
    checked: boolean;
    selectItem: () => void;
}

/**
 *
 * @param props
 */
export const TableSelectCell: React.FC<Props> = (props) => (
    <div
        className="scl-row-selection"
        style={{
            display: "inline-flex",
            flexDirection: "row",
            flexGrow: 0,
            alignItems: "center",
        }}
    >
        <div
            className="scl-row-selection__checkbox"
            style={{
                flex: 1,
                flexGrow: 0,
                marginRight: "5px",
            }}
        >
            <Button
                theme={props.checked ? {
                    paletteState: ThemePaletteState.DANGER,
                    shadow: ThemeShadowSizes.TINY,
                } : {
                    palette: ThemePalette.CONTRAST_PRIMARY,
                    shadow: ThemeShadowSizes.TINY,
                }}
                link={{ onClick: props.selectItem }}
            >
                {props.checked ? "Deselect" : "Select"}
            </Button>
        </div>
    </div>
);
